/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_ForbiddenInputs */



/**
* | output |
* | --- |
* | "You do not have access to this application" |
*
* @param {Error_ForbiddenInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const error_forbidden = /** @type {((inputs?: Error_ForbiddenInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_ForbiddenInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("You do not have access to this application")
	return /** @type {LocalizedString} */ ("Vous n'avez pas accès à cette application")
});